<script>
import TimeUtils from '@common/TimeUtils'
import StorageUtils from '@common/StorageUtils';
import ImageUtils from '@common/ImageUtils';
import FileUtils from '@common/FileUtils';
import PathBrowserify from 'path-browserify';
import FcmImageEditor from "@components/image/FcmImageEditor";
// Disable pdf
// import Pdf from 'vue-pdf';
// import path from 'path'
 // import {EventStatus, ProcedureType, Accommodation} from "@common/status";
// const path = require('path');

/*
 * Events:
 * @autoUploadOnInputEvent(this)          // quando autoUploadOnInput===true
 * @autoUploadOnEditorDoneEvent(this)     // quando autoUploadOnEditorDone===true
 * @changeFile({that: this, target: target})
 * @editorDone(this)
 * @autoUploadOnEditorDoneEvent(this)
 *
*/


const DEFAULT_VALUE = {
  url: null,
  mime: null,
  _tmp: {
    dataUrl: null,
    dataUrlOriginal: null,
    needUpload: false,
    needDelete: false,
    mimeOriginal: null,
    name: null,
    ext: null,
    loaded: false,
  }
};

export default {
  name: 'FcmImage',
  components: {FcmImageEditor,
  //  Pdf
  },
  inject: {
    fcmGalleryList: { default: null }
  },
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    value: {
      validator: (value)=>{return true},
      default: ()=>{return {};},
    },
    pathFile: {
      type: String,
      default: '',
    },
    folder: {
      type: String,
      default: 'teste',
    },
    accept: {
      type: String,
      default: '*/*', // 'image/*, application/pdf'
    },
    typeRegexAccept: {
      type: String,
      default: '', // '(image\/.*)|(application\/pdf)'
    },
    format: {
      type: String,
      default: 'object', // object | raw  // Não foi concluida a implementação da opção raw
    },
    viewMinHeight: {
      type: String,
      default: '110px',
    },
    viewMinWidth: {
      type: String,
      default: '160px',
    },
    viewMaxHeight: {
      type: String,
      default: '200px',
    },
    viewMaxWidth: {
      type: String,
      default: '200px',
    },
    compressImageMode: {
      type: String,
      default: 'all', // all | jpeg | never
    },
    aspectRatio: {
      type: Number,
      default: 0
    },
    cropperWidth: {
      type: Number,
      default: 450
    },
    cropperHeight: {
      type: Number,
      default: 450
    },
    fillColor: {
      type: [String, null],
      default: null
    },
    mimeTypeImage: {
      type: [String],
      default: 'image/jpeg'
    },
    qualityArgument: {
      type: [Number],
      default: 0.8
    },
    formatCropper: {
      type: [String],
      default: 'squad' // squad | circle
    },
    disableCarousel: {
      type: Boolean,
    },
    disableControl: {
      type: Boolean,
    },
    autoUploadOnInput: {
      type: Boolean,
    },
    autoUploadOnEditorDone: {
      type: Boolean,
    },
    openEditorAfterAdd: {
      type: Boolean,
    },
    maxWidth: {
      type: Number,
      default: 1024
    },
    maxHeight: {
      type: Number,
      default: 1024
    },
    // Shown instead of a broken-image icon when the stored url fails to load (e.g. a dead
    // Storage link). Optional — leave unset to keep the previous no-fallback behavior.
    defaultImage: {
      type: String,
      default: null,
    },
    // When true, also shows defaultImage (display-only, not treated as a real selected file)
    // if there's no image at all yet. Off by default so "new record, nothing picked yet" still
    // renders empty, as before.
    showDefaultWhenEmpty: {
      type: Boolean,
      default: false,
    },
  },
  data(vm) {
    return {
      internalLazyValue: vm.updateInternalLazyValue(vm.value, true, true),
      internalErrorMessages: [],
      hasInput: false,
      hasError: null,
      imageLoadError: false,
      showEditor: false,
      isShowFileStandAlone: false,
      isShowPdf: false,
      pdfNumPages: 0,
      filePdfTmp: null,
      filePdfTmp2: null,
      filePdfTmpUrl: null,
      callEditorShowOnInputChange: false,
      callShowFileOnInputChange: false,
    }
  },
  computed: {
    internalValue: {
      get() {
        return this.internalLazyValue;
      },
      set(val) {
        this.updateInternalLazyValue(val, true);
      }
    },
    dataUrl: {
      get() {
        return this.internalLazyValue?._tmp?.dataUrl;
      },
      set(value) {
        this.updateInternalLazyValue({
          ...this.internalLazyValue,
          _tmp: {
            ...this.internalLazyValue?._tmp,
            dataUrl: value,
          }
        }, true);
      }
    },
    mime: {
      get() {
        return this.internalLazyValue?.mime;
      },
      set(value) {
        this.updateInternalLazyValue({
          ...this.internalLazyValue,
          mime: value,
        }, true);
      }
    },
    url: {
      get() {
        return this.internalLazyValue?.url;
      },
      set(value) {
        this.updateInternalLazyValue({
          ...this.internalLazyValue,
          url: value,
        }, true);
      }
    },
    dataUrlOriginal: {
      get() {
        return this.internalLazyValue?._tmp?.dataUrlOriginal;
      },
      set(value) {
        this.updateInternalLazyValue({
          ...this.internalLazyValue,
          _tmp: {
            ...this.internalLazyValue?._tmp,
            dataUrlOriginal: value,
          }
        }, true);
      }
    },
    needUpload: {
      get() {
        return this.internalLazyValue?._tmp?.needUpload;
      },
      set(value) {
        this.updateInternalLazyValue({
          ...this.internalLazyValue,
          _tmp: {
            ...this.internalLazyValue?._tmp,
            needUpload: value,
          }
        }, true);
      }
    },
    mimeOriginal: {
      get() {
        return this.internalLazyValue?._tmp?.mimeOriginal;
      },
      set(value) {
        this.updateInternalLazyValue({
          ...this.internalLazyValue,
          _tmp: {
            ...this.internalLazyValue?._tmp,
            mimeOriginal: value,
          }
        }, true);
      }
    },
    pathLocal: {
      get() {
        return PathBrowserify.join(this.folder, this.pathFile || this.$newId())+(this.internalLazyValue?._tmp?.ext?('.'+this.internalLazyValue?._tmp?.ext):'');
      }
    },
  },
  watch: {
    value(val) {
      this.updateInternalLazyValue(val, true, true);
    },
  },
  created () {
    this.fcmGalleryList && this.fcmGalleryList.register(this);
  },
  mounted: async function() {
  },
  beforeDestroy: function() {
    this.fcmGalleryList && this.fcmGalleryList.unregister(this);
  },
  methods: {
    reset () {
      this.hasInput = false;
      this.internalErrorMessages = [];
      this.updateInternalLazyValue(DEFAULT_VALUE, true);
      this.removeFocus();
    },
    resetValidation () {
      this.hasInput = false;
      this.internalErrorMessages = [];
    },
    validate (force=false) {
      this.internalErrorMessages = [];
      for (const rule of this.rules) {
        const result = typeof rule === 'function' ? rule(this.internalLazyValue) : rule;
        if (typeof result === 'string') {
          this.internalErrorMessages.push(result);
        }
      }
      if (force) {
        this.hasInput = true;
      }
      return this.internalErrorMessages.length === 0;
    },

    /**
     * Formato dos dados de saída
     */
    toModel(value) {
      switch(this.format) {
        case 'object':
          return value;
        case 'raw':
          return value.url || null;
        default:
          console.error('Format invalido', this.format);
          return;
      }
    },
    toModelClear(value) {
      switch(this.format) {
        case 'object':
          const tmp = Object.assign(value);
          delete tmp._tmp;
          return tmp;
        case 'raw':
          return value.url || null;
        default:
          console.error('Format invalido', this.format);
          return;
      }
    },
    removeFocus() {

    },
    /**
     * Alterar esse método para manter a consistência do seu dado interno (internalLazyValue)
     * @param value
     * @param emit
     * @param tryInitByUrl
     */
    updateInternalLazyValue(value, emit=false, tryInitByUrl=false) {
      if(tryInitByUrl){
        const tmp = value?._tmp?.dataUrl  || value?.url;
        if(!tmp || (this.filePdfTmpUrl!==value?._tmp?.dataUrl && this.filePdfTmpUrl!==value?.url)) {
          this.filePdfTmp = null;
          this.filePdfTmp2 = null;
          this.pdfNumPages = null;
          this.filePdfTmpUrl = null;
        }
      }
      switch(this.format) {
        case 'object':
          value = {...value, url: value?.url || null, mime: value?.mime || null};
          break;
        case 'raw':
          if(value && typeof value!=='string') {
            console.error('Format raw com dados inconsistentes', value);
            return;
          }
          break;
        default:
          console.error('Format invalido', this.format);
          return;
      }

      if(!value) {
        value = _.cloneDeep(DEFAULT_VALUE);
      }
      if (!_.isEqual(this.internalLazyValue, value)) {
        this.resetValidation();
        this.imageLoadError = false;
        this.internalLazyValue = _.cloneDeep(value);
        if(emit) {
          this.$emit('input', this.toModel(this.internalLazyValue));
        }
        if(tryInitByUrl && value.url && !value?._tmp?.loaded) {
          this.initByUrl(value.url, value.mime);
        }
      }
      return value;
    },
    async loadPdf(url) {
      if(!url) {
        console.error('Url não encontrada para carregar o pdf para visualização', url);
        return;
      }
      this.filePdfTmpUrl = url;
      // this.filePdfTmp = Pdf.createLoadingTask(url);
      // this.filePdfTmp2 = await this.filePdfTmp.promise;
      // this.pdfNumPages = (this.filePdfTmp2?.numPages) || 0;
    },

    async initByUrl(url, mime) {
      if(!mime || !mime.includes('image/')) {
        mime = this.mimeTypeImage || 'image/jpeg';
      }
      if(mime?.includes('image/')) {
        const dataUrl = await FileUtils.urlToDataURL(url);
        const name = /([^/\?]+)($|\?)/.exec(decodeURIComponent(url))[1];
        const ext = /\.([^\./\?]+)($|\?)/.exec(url)[1];
        this.updateInternalLazyValue({
          ...this.internalLazyValue,
          _tmp: {
            ...this.internalLazyValue?._tmp,
            dataUrlOriginal: dataUrl,
            dataUrl: dataUrl,
            needUpload: false,
            needDelete: false,
            mimeOriginal: this.internalLazyValue?.mime || null,
            name: name,
            ext: ext,
            needCompress: false,
            loaded: true,
          }
        }, true);
      }
      else if(mime==='application/pdf'){}
      else {
        console.warn('mime não reconhecido', mime);
      }
    },
    async updatePreview() {
      this.$refs?.fcmImageEditor?.updatePreview?.();
    },
    async makeUpload(progressFn) {
    //  console.log('this.internalLazyValue', this.internalLazyValue)
      if(typeof progressFn!=='function') {progressFn = ()=>{};}
      if(!this.folder) {
        console.error('É necessário definir o atributo folder');
        this.$showError({title: this.$t('fcm.errors.needFolder')});
      }
      if(this.internalLazyValue?._tmp?.needDelete) {
        await StorageUtils.removeFile(this.pathLocal);
        return;
      }
      if(!this.internalLazyValue?._tmp?.needUpload) {
        return;
      }
      if(this.hasError) {
        console.error('Há um erro no arquivo', this.hasError);
        this.$showError({title: this.$t('fcm.errors.fileNotWillBeUpload')});
        return;
      }
      try {
        if (this.showEditor) {
          await this.updatePreview();
        }
        let data = this.dataUrl;
        let w = null;
        let h = null;

        if(this.internalLazyValue?._tmp?.needCompress) {
          const result = await ImageUtils.compactImageFromDataUrl(data, this.mimeTypeImage);
          if(result.isOk) {
            data = result.dataUrl;
            w = result.w || null;
            h = result.h || null;
          }
        }
        else {
          const size = await ImageUtils.getSizesFromDataUrl(data);
          if(size.isOk) {
            w = size.w || null;
            h = size.h || null;
          }
        }
        const url = await StorageUtils.uploadString(this.pathLocal, data, (p)=>{
          progressFn(p||0);
        });
        this.updateInternalLazyValue({
          ...this.internalLazyValue,
          url: url,
          w: w,
          h: h,
          _tmp: {
            ...this.internalLazyValue?._tmp,
            needUpload: false,
            needDelete: false,
          }
        }, true);
      } catch(err) {
        console.error('Erro ao tentar fazer upload de arquivo', err);
      }
      progressFn(1);
    },
    async changeInput(event) {
      this.hasError = null;
      const file = event.target?.files?.[0];
      if(!file) {
        console.warn('File not selected');
        return;
      }

      let mimeOriginal = file.type;
      let mime = file.type;
      let name = file.name;
      let ext = /(?:\.([^.]+))?$/.exec(file.name)[1]

      let needCompress = false;
      if(file.type.includes('image/')) {
        switch (this.compressImageMode) {
          case 'all':
            mime = this.mimeTypeImage || 'image/jpeg';
            needCompress = true;
            if (mime === 'image/png') ext = 'png';
            else if (mime === 'image/webp') ext = 'webp';
            else ext = 'jpg';
            break;
          case 'none':
            break;
          case 'jpeg':
            if(file.type==='image/jpeg' || file.type==='image/jpg') {
              mime = 'image/jpeg';
              ext= 'jpg';
              needCompress = true;
            }
            break;
          default:
            console.warn('CompressImageMode desconhecido', this.compressImageMode);
        }
      }
      if(this.typeRegexAccept) {
        const re = new RegExp(this.typeRegexAccept);
        if(!re.test(this.type)) {
          console.error('Tipo de arquivo não permitido', this.type);
          this.$showError({title: this.$t('fcm.errors.fileTypeNotAllowed')});
          this.hasError = true;
          return;
        }
      }
      const reader = new FileReader();
      reader.onload = (event) => {
        this.updateInternalLazyValue({
          ...this.internalLazyValue,
          mime: mime,
          _tmp: {
            ...this.internalLazyValue?._tmp,
            dataUrlOriginal: event.target.result,
            dataUrl: event.target.result,
            needUpload: true,
            needDelete: false,
            mimeOriginal: mimeOriginal,
            name: name,
            ext: ext,
            needCompress: needCompress,
            loaded: true,
          }
        }, true);
        this.$emit('changeFile', {that: this, target: event.target});

        if(this.callEditorShowOnInputChange) {
          this.editorShow(true);
        }
        if(this.callShowFileOnInputChange) {
          this.showFile(true);
        }
        if(this.autoUploadOnInput) {
          setTimeout(async ()=>{
            await this.makeUpload();
            this.$emit('autoUploadOnInputEvent', this);
          }, 1)
        }
      };
      reader.readAsDataURL(file);
    },
    async addFile() {
      if(this.openEditorAfterAdd) {
        this.callEditorShowOnInputChange = true;
      }
      await this._addFile();
    },
    async _addFile() {
      this.$refs.inputRef.click();
    },
    async editFile() {
      if(!this?.internalValue?._tmp?.dataUrl && !this?.internalValue?.url) {
        await this._addFile();
        this.callEditorShowOnInputChange = true
      }
      else {
        await this.editorShow();
      }
    },
    editorDone() {
    //  console.trace('editorDone');
      this.$emit('editorDone', this);

      if(this.autoUploadOnEditorDone) {
        setTimeout(async ()=>{
          await this.makeUpload();
          this.$emit('autoUploadOnEditorDoneEvent', this);
        }, 1);
      }
      else if(this.showEditor) {
        this.needUpload = true;
      }
      if(this.showEditor) {
        this.showEditor = false;
        this.updateInternalLazyValue({
          ...this.internalLazyValue,
          _tmp: {
            ...this.internalLazyValue?._tmp,
            needCompress: false,
          }
        }, false);
      }
      this.isShowPdf = false;
    },
    editorClose() {
   //   console.trace('editorClose');
      this.showEditor = false;
      this.needUpload = true;
      this.isShowPdf = false;
    },
    async editorShow(doNotTryAdd=false) {
      if(!doNotTryAdd && !this?.internalValue?._tmp?.dataUrl && !this?.internalValue?.url) {
        await this._addFile();
        this.callEditorShowOnInputChange = true;
        return;
      }
      this.callEditorShowOnInputChange = false;
      if(!this.mime) {
        console.error('Tipo de arquivo não encontrado');
      }
      if(this.mime?.includes('image/')) {
        this.showEditor = true;
      }
      else if(this.mime==='application/pdf') {
        if(this.autoUploadOnEditorDone && this.needUpload) {
          setTimeout(async ()=>{
            await this.makeUpload();
            this.$emit('autoUploadOnEditorDoneEvent', this);
          }, 1);
        }
        else {
          // Não é possível exibir ao fazer upload, pois o update que vem após a atualização muda a url
          await this.showPdf();
        }
      }
      else {
        console.warn('Tipo de arquivo indisponível para visualização');
        setTimeout(async ()=>{
          await this.makeUpload();
          this.$emit('autoUploadOnEditorDoneEvent', this);
        }, 1);
      }
    },
    async showPdf() {
      if(!this.filePdfTmp) {
        await this.loadPdf(this.dataUrl || this.url);
      }
      this.isShowPdf = true;
    },
    closePdf() {
      this.isShowPdf = false;
    },
    async removeFile() {
      const result = await this.$showConfirm({title: this.$t('fcm.confirmDelete')})
      if(!result) {
        return;
      }
      this.updateInternalLazyValue({
        ...this.internalLazyValue,
        mime: null,
        url: null,
        _tmp: {
          ...this.internalLazyValue?._tmp,
          needUpload: false,
          needDelete: true,
          dataUrl: null,
          dataUrlOriginal: null,
          mimeOriginal: null,
          name: null,
          ext: null,
          loaded: false,
        }
      }, true);
      this.editorClose();
      if(this.$refs.inputRef) {
        this.$refs.inputRef.value = '';
      }
    },
    async showFile(doNotTryAdd=false) {
      if(!doNotTryAdd && !this?.internalValue?._tmp?.dataUrl && !this?.internalValue?.url) {
        await this._addFile();
        this.callShowFileOnInputChange = true;
        return;
      }
      this.callShowFileOnInputChange = false;
      if(this.mime?.includes('image/')) {
        await this.updatePreview();
        if(this.fcmGalleryList && !this.disableCarousel) {
          this.fcmGalleryList.showCarousel(this);
        }
        else {
          this.isShowFileStandAlone = true;
        }
      }
      else if(this.mime==='application/pdf') {
        await this.showPdf();
      }
      else {
        console.warn('Tipo de arquivo indisponível para visualização');
      }
    },
    closeFile() {
      this.isShowFileStandAlone = false;
      this.isShowPdf = false;
      this.showEditor = false;
      this.fcmGalleryList?.closeCarousel?.();
    },
    async closeImageStandAlone() {
      this.isShowFileStandAlone = false;
    },
    showFileStandAlone() {
      this.isShowFileStandAlone = true;
    },
    inputInputEvent() {
      // Necessário para não propagar o event do input
    },
    onImageError() {
      if (this.defaultImage) {
        this.imageLoadError = true;
      }
    },
    openInNewTab() {
      if(this.url) {
        window.open(this.url, '_blank').focus();
      }
      else {
        console.error('É necessário enviar para o servidor antes de abrir em nova aba');
        this.$showError({title: this.$t('fcm.errors.needUploadToServerToSeeInTab')})
      }
    },
  },
}
</script>


<template>
  <div class="FcmImageBox" v-bind="$attrs" v-on="$listeners">
    <input ref='inputRef' style="display: none;" type="file" :accept="accept" @change="changeInput" @input.stop="inputInputEvent" />
    <FcmImageEditor ref="fcmImageEditor"
                    v-model="dataUrl"
                    :data-url-original="dataUrlOriginal"
                    :show-modal="showEditor"
                    show-extra-actions
                    :aspect-ratio="aspectRatio"
                    :cropper-width="cropperWidth"
                    :cropper-height="cropperHeight"
                    :fill-color="fillColor"
                    :mime-type="mimeTypeImage"
                    :quality-argument="qualityArgument"
                    format-cropper="formatCropper"
                    :max-width="maxWidth"
                    :max-height="maxHeight"
                    @done="editorDone"
                    @cancel="editorClose"
                    @show="showFile"
                    @remove="removeFile"
                    @selectNewFile="addFile"
    ></FcmImageEditor>
    <VDialog v-model="isShowFileStandAlone"
             fullscreen
             hide-overlay
             transition="dialog-bottom-transition"
             :content-class="$style.FcmDialogContent"
    >
      <div class="boxShowImage">
        <div class="contentShowImage">
          <img v-if="dataUrl" :src="dataUrl" alt="Image for upload">
        </div>
        <div class="controlShowImage">
          <VBtn fab elevation="2" x-small @click="closeImageStandAlone">
            <VIcon>mdi-close</VIcon>
          </VBtn>
          <VBtn v-if="!disableControl" fab elevation="2" x-small @click="removeFile">
            <VIcon>mdi-delete</VIcon>
          </VBtn>
          <VBtn v-if="!disableControl" fab elevation="2" x-small @click="addFile">
            <VIcon>mdi-selection-search</VIcon>
          </VBtn>
          <VBtn v-if="url && !disableControl" fab elevation="2" x-small @click="openInNewTab">
            <VIcon>mdi-open-in-new</VIcon>
          </VBtn>
          <VBtn v-if="!disableControl" fab elevation="2" x-small @click="editFile">
            <VIcon>mdi-pencil</VIcon>
          </VBtn>
        </div>
      </div>
    </VDialog>
    <VDialog v-if="filePdfTmp" v-model="isShowPdf"
             fullscreen
             hide-overlay
             transition="dialog-bottom-transition"
             :content-class="$style.FcmDialogContentPdf"
    >
      <div class="boxShowPdf">
        <div class="contentShowPdf">
<!--          <Pdf-->
<!--              v-for="i in pdfNumPages"-->
<!--              :key="i"-->
<!--              class="viwerShowPdf"-->
<!--              :src="filePdfTmp"-->
<!--              :page="i"-->
<!--          >-->
<!--          </Pdf>-->
        </div>
        <div class="controlShowPdf">
          <VBtn fab elevation="2" x-small @click="closePdf">
            <VIcon>mdi-close</VIcon>
          </VBtn>
          <VBtn fab elevation="2" x-small @click="removeFile">
            <VIcon>mdi-delete</VIcon>
          </VBtn>
          <VBtn fab elevation="2" x-small @click="addFile">
            <VIcon>mdi-selection-search</VIcon>
          </VBtn>
          <VBtn v-if="url" fab elevation="2" x-small @click="openInNewTab">
            <VIcon>mdi-open-in-new</VIcon>
          </VBtn>
        </div>
      </div>
    </VDialog>
    <slot name="content" v-bind="{
      events: {addFile, editFile, removeFile, showFile, showFileStandAlone, openInNewTab},
      dataUrl,
      dataUrlOriginal,
      url,
      mime,
      pathLocal
    }" >
      <div class="content">
        <div v-if="dataUrl || url || (showDefaultWhenEmpty && defaultImage)" class="image-wrapper" :style="(viewMinHeight?`min-height: ${viewMinHeight};`:'')+(viewMinWidth?`min-width: ${viewMinWidth};`:'')+(viewMaxHeight?`max-height: ${viewMaxHeight};`:'')+(viewMaxWidth?`max-width: ${viewMaxWidth};`:'')">
          <img v-if="dataUrl || url" :src="imageLoadError && defaultImage ? defaultImage : (dataUrl || url)" alt="Image for upload" @error="onImageError">
          <img v-else-if="showDefaultWhenEmpty && defaultImage" :src="defaultImage" alt="Image for upload">
        </div>
        <div class="control">
          <VBtn icon small @click="addFile">
            <VIcon>mdi-select-search</VIcon>
          </VBtn>
          <VBtn icon small @click="editFile">
            <VIcon>mdi-pencil</VIcon>
          </VBtn>
          <VBtn v-if="dataUrl || url" icon small @click="removeFile">
            <VIcon>mdi-delete</VIcon>
          </VBtn>
          <VBtn icon small @click="showFile">
            <VIcon>mdi-eye</VIcon>
          </VBtn>
          <VBtn v-if="url" icon small @click="openInNewTab">
            <VIcon>mdi-open-in-new</VIcon>
          </VBtn>
        </div>
      </div>
    </slot>
  </div>
</template>


<style lang="scss" scoped>
  // @import '@design';
  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    border: 1px dashed rgba(255, 255, 255, 0.1);
    border-radius: 4px;
    padding: 8px;
    width: fit-content;
    margin: 0 auto;

    .image-wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;
      background-color: rgba(0, 0, 0, 0.2);
      border-radius: 2px;
      img {
        max-width: 100%;
        max-height: 100%;
        object-fit: contain;
      }
    }

    .control {
      margin-top: 12px;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      background: rgba(255, 255, 255, 0.08);
      border-radius: 24px;
      padding: 4px 12px;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
    }
  }
  .boxShowImage {
    width: 100%;
    height: 100%;
    position: relative;
    .controlShowImage {
      position: absolute;
      top: 5px;
      left: 5px;
      > button{
        margin-right: 4px;
      }
    }
    .contentShowImage {
      max-height: 100%;
      max-width: 100%;
      margin: 0 auto;
      img {
        max-height: 100%;
        max-width: 100%;
      }
    }
  }

  .boxShowPdf {
    width: 100%;
    height: 100%;
    position: relative;
    .controlShowPdf {
      position: absolute;
      top: 5px;
      left: 5px;
      > button{
        margin-right: 4px;
      }
    }
    .contentShowPdf {
      max-height: 100%;
      max-width: 100%;
      margin: 0 auto;
      .viwerShowPdf {
        //max-height: 100%;
        //max-width: 100%;
        border-bottom: solid 1px #bfb5bb;
      }
    }
  }

</style>

<style lang="scss" module>
.FcmDialogContent {
  background-color: var(--v-modalBg-base);
}

.FcmDialogContentPdf {
  background-color: var(--v-modalBg-base);
}
</style>



















